import { get, post, put, del } from 'lib/API';
import Brand from 'data/Brand';
import BrandVendor from 'data/BrandVendor';

export const loadBrands = async ([vendorId]: any[], { token }: any): Promise<Brand[]> => {
  return await get(`v1/brands${vendorId ? '?vendorId=' + vendorId : ''}`, token);
};

export const createBrand = async ([newBrand, vendorId]: any[], { token }: any): Promise<any> => {
  return await post('v1/brands', token, {
    name: newBrand.name,
    vendorId,
    description: newBrand.description,
    keywords: newBrand.keywords,
    mediaId: newBrand.media && newBrand.media.length > 0 ? newBrand.media[0].id : null,
    isMaterialApiEnabled: newBrand.isMaterialApiEnabled,
    authenticationUrl: newBrand.authenticationUrl,
    baseUrl: newBrand.baseUrl,
    consumerKey: newBrand.consumerKey,
    consumerSecret: newBrand.consumerSecret,
    isStockApiEnabled: newBrand.isStockApiEnabled,
    isParentBrand: newBrand.isParentBrand,
    title: newBrand.title,
    trustedSince: newBrand.trustedSince,
    seoTitle: newBrand.seoTitle,
    seoDescription: newBrand.seoDescription,
    selectedBrandsIds: newBrand.selectedBrandsIds,
  });
};

export const saveBrand = async ([brandToUpdate, vendorId]: any[], { token }: any): Promise<any> => {
  return await put(`v1/brands/${brandToUpdate.id}`, token, {
    name: brandToUpdate.name,
    vendorId,
    description: brandToUpdate.description,
    keywords: brandToUpdate.keywords,
    mediaId: brandToUpdate.media && brandToUpdate.media.length > 0 ? brandToUpdate.media[0].id : null,
    isMaterialApiEnabled: brandToUpdate.isMaterialApiEnabled,
    authenticationUrl: brandToUpdate.authenticationUrl,
    baseUrl: brandToUpdate.baseUrl,
    consumerKey: brandToUpdate.consumerKey,
    consumerSecret: brandToUpdate.consumerSecret,
    isStockApiEnabled: brandToUpdate.isStockApiEnabled,
    isSalesOrderApiEnabled: brandToUpdate.isSalesOrderApiEnabled,
    isParentBrand: brandToUpdate.isParentBrand,
    title: brandToUpdate.title,
    trustedSince: brandToUpdate.trustedSince,
    seoTitle: brandToUpdate.seoTitle,
    seoDescription: brandToUpdate.seoDescription,
    selectedBrandsIds: brandToUpdate.selectedBrandsIds,
  });
};

export const loadBrand = async ([brandId]: any[], { token }: any): Promise<Brand> => {
  return await get(`v1/brands/${brandId}`, token);
};

export const deleteBrandOldMedia = (brandId: number, mediaId: number, token: string): Promise<any> => {
  return del(`v1/brandOldMedia?brandId=${brandId}&mediaId=${mediaId}`, token);
};

export const deleteBrandMedia = (brandId: number, mediaId: number, token: string): Promise<any> => {
  return del(`v1/brandMedia?brandId=${brandId}&mediaId=${mediaId}`, token);
};

export const saveBrandConfiguration = async ([configuration, brandId]: any[], { token }: any): Promise<any> => {

  const brandConfiguration = {
    autoApproveAfterDays: configuration.autoApproveAfterDays || null,
    autoApproveEnabled: configuration.autoApproveEnabled || false,
    thirdReminderDays: configuration.thirdReminderDays || null,
    firstReminderDays: configuration.firstReminderDays,
    rentReminderDays: configuration.rentReminderDays,
    secondReminderDays: configuration.secondReminderDays,
  }
  
  return await put(`v1/brands/${brandId}/configuration`, token, brandConfiguration);
};

export const loadBrandVendor = async ([vendorId, brandId]: any[], { token }: any): Promise<any> => {
  return await get(`v1/brands/${vendorId}/${brandId}/configuration`, token);
}

export const updateBrandVendorConfiguration = async ([vendorId, brandId, payload]: any[], { token }: any): Promise<any> => {
  return await put(`v1/brands/${vendorId}/${brandId}/configuration`, token, payload);
}

export const getBuyNowConfiguration = async ([brandCode]: any[], { token }: any): Promise<any> => {
  return await get(`v1/brands/${brandCode}/getBuyNowConfiguration`, token);
}

export const loadAffiliateApproverEmails = async (brandId: number, token: string): Promise<any> => {
  return await get(`v1/brands/${brandId}/affiliate-payment-approver-emails`, token);
};

export const saveAffiliateApproverEmails = async (brandId: number, emails: string, token: string): Promise<any> => {
  return await put(`v1/brands/${brandId}/affiliate-payment-approver-emails`, token, { emails });
};